import {Component, OnInit} from '@angular/core';
import {ModelService} from "../services/model.service";

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {
    private brandClass: string;

    constructor(protected modelService: ModelService) {
    }

    ngOnInit() {
        switch (this.modelService.user.brand) {
            case '-':
                this.brandClass = 'headernobrand';
                break;
            case 'REN':
                this.brandClass = 'headerrenault';
                break;
            case 'NIS':
                this.brandClass = 'headernissan';
                break;
            case 'INF':
                this.brandClass = 'headerinfiniti';
                break;
        }
    }
}
